import { Injectable } from "@angular/core";
import { StorageEnum } from "../enums/storage.enum";

@Injectable()
export class StorageService {

    private storage;

    constructor(){
        this.storage = new Map();
    }

    setParam(key: StorageEnum, value: any) {
        if(this.storage.has(key)) this.storage.delete(key);
        this.storage.set(key, value);
    }

    getParam(key: StorageEnum) {
        if(this.storage.has(key)){
            const value = this.storage.get(key);
            this.storage.delete(key);
            return value;
        }
        return null;
    }

}
